(function () {
  var PRICE_CLASS = "rk_price";
  var QTY_CLASS = "rk_qty";
  var FRAC = "[\u00BD\u2153\u2154\u00BC\u00BE\u215B\u215C\u215D\u215E]";
  var QTY_NUM = "(?:\\d+(?:[.,]\\d+)?(?:\\s*" + FRAC + ")?|" + FRAC + ")";
  var QTY_UNIT =
    "kleine\\s+Tasse|Esslöffel|Teelöffel|Stück|Prisen?|Tassen?|Zehen?|Dosen?|Packung|Bund|Glas|Pck\\.?|Stk\\.?|EL|TL|kg|ml|g|l";
  var QTY_RE = new RegExp(
    "^(" +
      QTY_NUM +
      "(?:\\s*[–-]\\s*" +
      QTY_NUM +
      ")?(?:\\s*(?:" +
      QTY_UNIT +
      "))?)\\s+",
    "i"
  );
  var LEADING_UNIT_RE = new RegExp("^(" + QTY_UNIT + ")\\.?\\s+", "i");

  function shopConfig() {
    return window.rkShop || {};
  }

  function formatMoney(value) {
    var n = Number(value);
    if (!isFinite(n)) return "";
    var format = shopConfig().moneyFormat;
    if (format) {
      var dotted = n.toFixed(2);
      var comma = dotted.replace(".", ",");
      var rounded = String(Math.round(n));
      return format
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, comma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, rounded)
        .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, dotted.replace(/\B(?=(\d{3})+(?!\d))/g, " ").replace(".", ","))
        .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, rounded.replace(/\B(?=(\d{3})+(?!\d))/g, " "))
        .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, dotted.replace(/\B(?=(\d{3})+(?!\d))/g, "'"))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, rounded)
        .replace(/\{\{\s*amount\s*\}\}/g, dotted);
    }
    var currency = shopConfig().currency || "EUR";
    var lang = (document.documentElement.getAttribute("lang") || "de").replace("_", "-");
    try {
      return new Intl.NumberFormat(lang, {
        style: "currency",
        currency: currency
      }).format(n);
    } catch (err) {
      return dottedFallback(n, currency);
    }
  }

  function dottedFallback(n, currency) {
    return n.toFixed(2) + " " + currency;
  }

  function recipeData() {
    var el = document.querySelector('script[id^="recipe-data-"]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (err) {
      return null;
    }
  }

  function normalize(value) {
    return String(value || "")
      .replace(/<[^>]+>/g, " ")
      .replace(/&nbsp;/gi, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  }

  function withoutQty(value) {
    return normalize(value).replace(QTY_RE, "");
  }

  function numericId(value) {
    var match = String(value || "").match(/(\d{8,})/);
    return match ? match[1] : "";
  }

  function shoppableRoot(row) {
    return row.querySelector(".rk_shoppable") || row;
  }

  function stripLeadingQty(el, prefix) {
    if (!el || !prefix) return;
    var remaining = prefix.replace(/\s+/g, " ").trim();
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    var i;
    var value;
    var lead;
    var re;
    var match;
    for (i = 0; i < nodes.length && remaining; i += 1) {
      value = nodes[i].nodeValue.replace(/^\s+/, "").replace(/\s+/g, " ");
      if (!value.trim()) continue;
      re = remaining.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      match = value.match(new RegExp("^" + re + "\\s*", "i"));
      if (match) {
        nodes[i].nodeValue = value.slice(match[0].length);
        remaining = "";
        break;
      }
      lead = value.trim();
      if (remaining.toLowerCase().indexOf(lead.toLowerCase()) === 0) {
        remaining = remaining.slice(lead.length).replace(/^\s+/, "");
        nodes[i].nodeValue = "";
      } else {
        break;
      }
    }
  }

  function stripLeadingUnit(el) {
    if (!el) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var node;
    var value;
    var match;
    while ((node = walker.nextNode())) {
      value = node.nodeValue.replace(/^\s+/, "");
      if (!value.trim()) continue;
      match = value.match(LEADING_UNIT_RE);
      if (match) {
        node.nodeValue = value.slice(match[0].length);
      }
      break;
    }
  }

  function ingredientBody(row) {
    return (
      row.querySelector(".rk_shoppable_body") ||
      row.querySelector(".rk_ingredient_content") ||
      row
    );
  }

  function splitQty(row) {
    var body = ingredientBody(row);
    var text = (body.textContent || "").replace(/\s+/g, " ").trim();
    var match = text.match(QTY_RE);
    var qty = row.querySelector("." + QTY_CLASS);
    if (!match || !match[1]) {
      if (qty && row.classList.contains("rk_has_qty")) stripLeadingUnit(body);
      return;
    }
    var qtyText = match[1].trim();
    if (qty) {
      if (qty.textContent !== qtyText) qty.textContent = qtyText;
    } else {
      qty = document.createElement("span");
      qty.className = QTY_CLASS;
      qty.textContent = qtyText;
      row.insertBefore(qty, row.firstElementChild);
      row.classList.add("rk_has_qty");
    }
    var link = body.querySelector("a.rk_has_link");
    var linkText = link ? (link.textContent || "").replace(/\s+/g, " ").trim() : "";
    if (link && linkText.toLowerCase().indexOf(qtyText.toLowerCase()) === 0) {
      link.textContent = linkText.slice(match[0].length).trim() || linkText;
    }
    stripLeadingQty(body, qtyText);
    stripLeadingUnit(body);
  }

  function syncQuantities() {
    document.querySelectorAll("#rk_parent .rk_ingredients li").forEach(splitQty);
  }

  var productJsonCache = {};

  function shopRoot() {
    return (
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      "/"
    );
  }

  function shippingPolicyUrl() {
    var cfg = shopConfig().shippingPolicyUrl;
    if (cfg) return cfg;
    return shopRoot().replace(/\/?$/, "/") + "policies/shipping-policy";
  }

  function fetchProductJson(handle) {
    if (!handle) return Promise.resolve(null);
    if (Object.prototype.hasOwnProperty.call(productJsonCache, handle)) {
      return productJsonCache[handle];
    }
    productJsonCache[handle] = fetch(
      shopRoot().replace(/\/?$/, "/") +
        "products/" +
        encodeURIComponent(handle) +
        ".js"
    )
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
    return productJsonCache[handle];
  }

  function formatQuantityValue(value) {
    var raw = String(value == null ? "" : value);
    if (/^\d+\.0+$/.test(raw)) return raw.replace(/\.0+$/, "");
    return raw;
  }

  function formatReferenceLabel(measurement) {
    var refVal = Number(measurement.reference_value);
    var refUnit = String(measurement.reference_unit || "");
    if (!isFinite(refVal) || refVal === 1) return refUnit;
    return String(measurement.reference_value).replace(/\.0+$/, "") + refUnit;
  }

  function formatUnitPriceLine(unitPriceCents, measurement) {
    if (!unitPriceCents || !measurement) return "";
    var qty = formatQuantityValue(measurement.quantity_value);
    var qUnit = String(measurement.quantity_unit || "");
    var money = formatMoney(Number(unitPriceCents) / 100);
    var ref = formatReferenceLabel(measurement);
    if (!qty || !qUnit || !money || !ref) return "";
    return "Inhalt: " + qty + " " + qUnit + " (" + money + " / " + ref + ")";
  }

  function findVariantUnitData(productJson, variantId) {
    var variants = (productJson && productJson.variants) || [];
    var i;
    var match = null;
    if (variantId) {
      for (i = 0; i < variants.length; i += 1) {
        if (String(variants[i].id) === String(variantId)) {
          match = variants[i];
          break;
        }
      }
    }
    if (!match) match = variants[0];
    if (!match) return null;
    return {
      unitPrice: match.unit_price,
      measurement: match.unit_price_measurement
    };
  }

  function addPrice(root, amount, compare, handle, variantId) {
    var body = root.querySelector(".rk_shoppable_body") || root;
    if (body.querySelector(".rk_price_block")) return;
    var formatted = formatMoney(amount);
    if (!formatted) return;

    var block = document.createElement("div");
    block.className = "rk_price_block";

    var price = document.createElement("span");
    price.className = PRICE_CLASS;
    if (compare && Number(compare) > Number(amount)) {
      var was = document.createElement("s");
      was.textContent = formatMoney(compare);
      price.appendChild(was);
      price.appendChild(document.createTextNode(formatted));
    } else {
      price.textContent = formatted;
    }
    block.appendChild(price);

    var tax = document.createElement("span");
    tax.className = "rk_tax_note";
    tax.appendChild(document.createTextNode("inkl. MwSt. zzgl. "));
    var ship = document.createElement("a");
    ship.href = shippingPolicyUrl();
    ship.textContent = "Versand";
    tax.appendChild(ship);
    block.appendChild(tax);

    body.appendChild(block);

    if (!handle) return;
    fetchProductJson(handle).then(function (productJson) {
      var unit = findVariantUnitData(productJson, variantId);
      if (!unit) return;
      var line = formatUnitPriceLine(unit.unitPrice, unit.measurement);
      if (!line || !block.isConnected) return;
      if (block.querySelector(".rk_unit_price")) return;
      var unitEl = document.createElement("span");
      unitEl.className = "rk_unit_price";
      unitEl.textContent = line;
      block.insertBefore(unitEl, tax);
    });
  }

  function findRow(ing) {
    var product = ing.selected_product || {};
    var variant = (product.variants && product.variants[0]) || {};
    var handle = product.handle || "";
    var variantId = numericId(variant.id);
    var items = document.querySelectorAll("#rk_parent .rk_ingredients li");
    var i;
    var html;
    var hay;

    if (handle) {
      for (i = 0; i < items.length; i += 1) {
        html = items[i].innerHTML || "";
        if (
          html.indexOf("/products/" + handle) !== -1 ||
          html.indexOf(handle) !== -1
        ) {
          return items[i];
        }
      }
    }

    if (variantId) {
      for (i = 0; i < items.length; i += 1) {
        if ((items[i].innerHTML || "").indexOf(variantId) !== -1) {
          return items[i];
        }
      }
    }

    var needle = withoutQty(ing.ingredient);
    if (needle) {
      for (i = 0; i < items.length; i += 1) {
        hay = withoutQty(items[i].textContent);
        if (hay && (hay.indexOf(needle) !== -1 || needle.indexOf(hay) !== -1)) {
          return items[i];
        }
      }
    }

    return null;
  }

  function wrapProductPanel(li) {
    if (li.querySelector(":scope > .rk_product_panel")) return;
    var nested = li.querySelector(":scope > .rk_shoppable");
    if (nested && nested !== li) {
      nested.classList.add("rk_product_panel");
      return;
    }
    if (!li.classList.contains("rk_shoppable")) return;
    var panel = document.createElement("div");
    panel.className = "rk_shoppable rk_product_panel";
    Array.prototype.slice.call(li.children).forEach(function (child) {
      if (child.classList.contains("rk_qty") || child.classList.contains("select_div")) return;
      panel.appendChild(child);
    });
    var qty = li.querySelector(":scope > .rk_qty");
    if (qty && qty.nextSibling) li.insertBefore(panel, qty.nextSibling);
    else li.appendChild(panel);
  }

  function placeCartButtons() {
    document.querySelectorAll("#rk_parent .rk_ingredients li").forEach(function (li) {
      wrapProductPanel(li);
      var box = li.querySelector(".select_div");
      if (!box) return;
      var panel = li.querySelector(":scope > .rk_product_panel, :scope > .rk_shoppable");
      if (panel && box.parentNode !== panel) panel.appendChild(box);
      else if (!panel && box.parentNode !== li) li.appendChild(box);
    });
  }

  function tagMetaIcons() {
    var map = [
      { re: /zubereitung|prep/i, key: "prep" },
      { re: /kochzeit|cook/i, key: "cook" },
      { re: /schwierig|difficulty/i, key: "level" },
      { re: /kategorie|category/i, key: "cat" },
      { re: /k(?:ü|ue)che|cuisine/i, key: "cuisine" },
      { re: /kcal|kalorien|calor|nähr|nutrition/i, key: "kcal" }
    ];
    document.querySelectorAll("#rk_parent .rk_details .rk_meta").forEach(function (el) {
      var text = (el.textContent || "").trim();
      var col = el.closest(".rk_column");
      var i;
      if (!col) return;
      for (i = 0; i < map.length; i += 1) {
        if (map[i].re.test(text)) {
          col.setAttribute("data-rk-icon", map[i].key);
          if (map[i].key === "prep" && /zubereitungszeit/i.test(text)) {
            el.textContent = "Zubereitung";
          }
          return;
        }
      }
    });
  }

  function relocateServings() {
    var root = document.querySelector("#rk_parent");
    if (!root) return;
    var ingredients = root.querySelector(".rk_ingredients");
    if (!ingredients) return;
    var servingRow = root.querySelector(".rk_serving_row");
    if (!servingRow) return;

    var metaCol = servingRow.closest(".rk_details .rk_column");
    if (metaCol) metaCol.classList.add("rk_servings_source");

    // Recipe Kit lässt bei Bereichen wie „2-3“ ein Label „-3“ stehen
    servingRow.querySelectorAll(".rk_serving_label").forEach(function (label) {
      label.remove();
    });

    var inline = ingredients.querySelector(".rk_inline_servings");
    if (!inline) {
      inline = document.createElement("div");
      inline.className = "rk_inline_servings";
      var pre = document.createElement("span");
      pre.className = "rk_inline_servings_pre";
      pre.textContent = "für";
      var post = document.createElement("span");
      post.className = "rk_inline_servings_post";
      post.textContent = "Portionen";
      inline.appendChild(pre);
      inline.appendChild(servingRow);
      inline.appendChild(post);
      var header = ingredients.querySelector(".rk_ingredients_header");
      if (header) header.insertAdjacentElement("afterend", inline);
      else {
        var list = ingredients.querySelector("ul");
        if (list) ingredients.insertBefore(inline, list);
        else ingredients.appendChild(inline);
      }
      return;
    }

    if (!inline.contains(servingRow)) {
      var postEl = inline.querySelector(".rk_inline_servings_post");
      if (postEl) inline.insertBefore(servingRow, postEl);
      else inline.appendChild(servingRow);
    }
  }

  function relocateNotes() {
    var root = document.querySelector("#rk_parent");
    if (!root) return;
    var directions = root.querySelector(".rk_directions");
    if (!directions) return;

    var heading = root.querySelector("#rk-notes");
    if (!heading) return;

    var col = heading.closest(".rk_column") || heading.parentElement;
    if (!col) return;

    col.classList.add("rk_tip");

    var tipText = col.querySelector("p");
    if (tipText) {
      tipText.textContent = String(tipText.textContent || "").replace(/^\s*Tipp:\s*/i, "");
    }

    if (!directions.contains(col)) {
      directions.appendChild(col);
    }
  }

  function enhance() {
    tagMetaIcons();
    syncQuantities();
    relocateServings();
    relocateNotes();
    document.querySelectorAll("#rk_parent .rk_ingredients li").forEach(function (row) {
      wrapProductPanel(row);
    });
    placeCartButtons();
    var data = recipeData();
    if (!data || !data.recipe_ingredients) return;
    data.recipe_ingredients.forEach(function (ing) {
      try {
        var product = ing.selected_product;
        var variant = product && product.variants && product.variants[0];
        if (!variant || !variant.price) return;
        var row = findRow(ing);
        if (!row) return;
        addPrice(
          shoppableRoot(row),
          variant.price,
          variant.compareAtPrice,
          product.handle,
          numericId(variant.id)
        );
      } catch (err) {}
    });
  }

  var cartRefreshTimer = null;

  function refreshDawnCart(cart) {
    var cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer || typeof cartDrawer.renderContents !== "function") return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(root + "?sections=cart-drawer,cart-icon-bubble")
      .then(function (res) {
        return res.json();
      })
      .then(function (sections) {
        if (!sections || !sections["cart-drawer"]) return;
        if (cart && Number(cart.item_count) === 0) {
          cartDrawer.classList.add("is-empty");
        } else {
          cartDrawer.classList.remove("is-empty");
        }
        cartDrawer.renderContents({ sections: sections });
      })
      .catch(function () {});
  }

  function scheduleCartRefresh(cart) {
    clearTimeout(cartRefreshTimer);
    cartRefreshTimer = setTimeout(function () {
      refreshDawnCart(cart);
    }, 200);
  }

  function watchThemeCart() {
    if (window.__rkCartWatch) return;
    window.__rkCartWatch = true;

    document.addEventListener("rk_cart_event", function (e) {
      scheduleCartRefresh(e && e.detail && e.detail.cart);
    });

    if (typeof window.fetch === "function") {
      var origFetch = window.fetch;
      window.fetch = function (input) {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        var result = origFetch.apply(this, arguments);
        if (
          /\/cart\/(add|change|update|clear)/.test(url) &&
          url.indexOf("sections=") === -1
        ) {
          result
            .then(function (res) {
              if (res && res.ok) scheduleCartRefresh();
            })
            .catch(function () {});
        }
        return result;
      };
    }
  }

  function boot() {
    enhance();
    var root = document.querySelector("#rk_parent");
    if (!root || root.dataset.rkPricesWatch) return;
    root.dataset.rkPricesWatch = "1";
    var qtyFrame = 0;
    var enhanceTimer = null;
    function scheduleQtySync() {
      if (qtyFrame) cancelAnimationFrame(qtyFrame);
      qtyFrame = requestAnimationFrame(function () {
        qtyFrame = 0;
        syncQuantities();
      });
    }
    function scheduleEnhance() {
      clearTimeout(enhanceTimer);
      enhanceTimer = setTimeout(enhance, 80);
    }
    new MutationObserver(function (mutations) {
      var structural = false;
      var textChange = false;
      var i;
      for (i = 0; i < mutations.length; i += 1) {
        if (mutations[i].type === "childList") structural = true;
        if (mutations[i].type === "characterData") textChange = true;
      }
      if (textChange) syncQuantities();
      else scheduleQtySync();
      if (structural) scheduleEnhance();
    }).observe(root, { childList: true, characterData: true, subtree: true });
    root.addEventListener("click", function (e) {
      if (
        e.target &&
        e.target.closest &&
        e.target.closest(".rk_serving_btn, .rk_serving_adjuster, .rk_serving_count, .rk_inline_servings")
      ) {
        syncQuantities();
        scheduleQtySync();
        requestAnimationFrame(scheduleQtySync);
        requestAnimationFrame(function () {
          requestAnimationFrame(scheduleQtySync);
        });
      }
    });
  }

  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    if (document.querySelector("#rk_parent .rk_shoppable") && recipeData()) {
      clearInterval(timer);
      boot();
    } else if (tries > 40) {
      clearInterval(timer);
      boot();
    }
  }, 250);

  watchThemeCart();
})();
